import {
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FILM_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    FORMATTED_SUBCATEGORY_MAP,
    MUSIC_EVENTBRITE_CATEGORY,
    NIGHTLIFE_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SUBCATEGORY_REFINEMENT_TO_KEY,
} from '@eventbrite/categories';
import { ArrowRightChunky, DiscoBall } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { getExperiment, logEvent } from '@eventbrite/statsig';
import React, { useEffect, useState } from 'react';
import {
    EVENTBRITE_FORMAT_MAPPING,
    PARTY_EVENTBRITE_FORMAT,
} from '../../../../discover/src/constants';
import {
    LISTING_NIGHTLIFE_PROMO_BANNER,
    STATSIG_EVENT_NAMES,
} from '../../constants';
import './NightlifePromoBanner.scss';

type Props = {
    category?: string;
    subcategory?: string;
    format?: string;
};

export const NightlifePromoBanner: React.FC<Props> = ({
    category,
    subcategory,
    format,
}) => {
    const [showNightlifePromoBanner, setNightlifePromoBanner] = useState(false);
    const titleFirstLine = gettext('Live your best nightlife.');
    const titleSecondLine = gettext('Discover more events.');
    const ctaLink = `/b/local/${EVENTBRITE_CATEGORY_TO_REFINEMENT[NIGHTLIFE_EVENTBRITE_CATEGORY]}/?utm_source=listing_nightlife_banner_click`;
    const validNightlifeBannerCategories = [
        EVENTBRITE_CATEGORY_MAPPING[MUSIC_EVENTBRITE_CATEGORY].toString(),
        EVENTBRITE_CATEGORY_MAPPING[
            FOOD_AND_DRINK_EVENTBRITE_CATEGORY
        ].toString(),
        EVENTBRITE_CATEGORY_MAPPING[FILM_EVENTBRITE_CATEGORY].toString(),
    ];
    const validNightlifeBannerSubcategory =
        FORMATTED_SUBCATEGORY_MAP[
            SUBCATEGORY_REFINEMENT_TO_KEY[PERFORMING_EVENTBRITE_CATEGORY][
                'comedy'
            ]
        ]['title'].toString();
    const validNightlifeBannerFormat =
        EVENTBRITE_FORMAT_MAPPING[PARTY_EVENTBRITE_FORMAT].toString();

    useEffect(() => {
        const variant = getExperiment(
            LISTING_NIGHTLIFE_PROMO_BANNER.experimentName,
            LISTING_NIGHTLIFE_PROMO_BANNER.param,
            LISTING_NIGHTLIFE_PROMO_BANNER.defaultValue,
        );
        setNightlifePromoBanner(variant == 'show');
    }, []);

    const _handleCtaOnClick = () => {
        logEvent(STATSIG_EVENT_NAMES.LISTING_NIGHTLIFE_BANNER_CLICK);
    };

    if (
        !showNightlifePromoBanner ||
        !(
            validNightlifeBannerCategories.includes(category || '') ||
            subcategory === validNightlifeBannerSubcategory ||
            format === validNightlifeBannerFormat
        )
    ) {
        return null;
    }

    return (
        <section
            className="nightlife_promo_banner"
            data-testid={'nightlife-promo'}
        >
            <a
                href={ctaLink}
                onClick={_handleCtaOnClick}
                data-heap-id="nightlife_banner__cta"
                data-show-nightlife-promo-banner={showNightlifePromoBanner}
            >
                <div className="nightlife-promo-banner-wrapper">
                    <div className="nightlife-promo-banner__image">
                        <DiscoBall />
                    </div>
                    <div className="nightlife_promo_banner__text">
                        <span className="text_title">{titleFirstLine} </span>
                        <span className="text_subtitle">{titleSecondLine}</span>
                    </div>
                    <div className="nightlife-promo-banner__arrow">
                        <ArrowRightChunky />
                    </div>
                </div>
            </a>
        </section>
    );
};
